import type { CityConfig } from "../city-template/types";

export const jacksonvilleNcConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Jacksonville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "jacksonville-nc",
  route: "/cities/jacksonville-nc",
  title: "Emergency Passport Jacksonville, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Jacksonville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Onslow County and Camp Lejeune area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Jacksonville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Jacksonville and Camp Lejeune area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20coastal%20view%20of%20Jacksonville%20North%20Carolina%20with%20Onslow%20Beach%20and%20the%20Atlantic%20Ocean%20in%20the%20background%2C%20warm%20golden%20afternoon%20sunlight%2C%20lush%20green%20coastal%20trees%2C%20calm%20coastal%20water%20reflecting%20blue%20sky%2C%20military%20base%20community%20with%20modern%20developments%2C%20professional%20landscape%20photography%20with%20vibrant%20warm%20colors%20and%20natural%20coastal%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings%2C%20clean%20modern%20coastal%20town%20scene&width=1800&height=700&seq=jacksonville-nc-hero-001&orientation=landscape",
  heroImageAlt: "Jacksonville North Carolina coastal area with Onslow Beach and Atlantic Ocean",
  geoPosition: "34.7541;-77.4302",
  geoPlacename: "Jacksonville, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 330 miles north of Jacksonville — about 5.5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Jacksonville", zips: "28540, 28541, 28542, 28543, 28544, 28546, 28547" },
    { name: "Richlands", zips: "28574" },
    { name: "Holly Ridge", zips: "28445" },
    { name: "Sneads Ferry", zips: "28460" },
    { name: "Swansboro", zips: "28584" },
    { name: "Hubert", zips: "28539" },
    { name: "Camp Lejeune", zips: "28542, 28547" },
    { name: "MCAS New River", zips: "28540" },
    { name: "Midway Park", zips: "28544" },
    { name: "Piney Green", zips: "28546" },
    { name: "Half Moon", zips: "28546" },
    { name: "North Topsail Beach", zips: "28460" },
    { name: "Surf City", zips: "28445" },
    { name: "Hampstead", zips: "28443" },
    { name: "Burgaw", zips: "28425" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Jacksonville departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Onslow County Hub", desc: "Serving Jacksonville, Camp Lejeune, and the coastal military community" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Wilmington, NC", route: "/cities/wilmington" },
    { name: "Fast passport renewal in Fayetteville, NC", route: "/cities/fayetteville" },
    { name: "Emergency passport help in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Urgent passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Same-day passport help in Durham, NC", route: "/cities/durham" },
    { name: "Passport courier services in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Expedited passport services in Greenville, NC", route: "/cities/greenville" },
    { name: "Fast passport renewal in New Bern, NC", route: "/cities/new-bern" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Jacksonville remotely via secure courier. We do not have a walk-in office in Jacksonville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Onslow County and the coastal military community travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Onslow County and the coastal military region including Camp Lejeune and MCAS New River",
  serviceAreaIntro: "From downtown Jacksonville to the military communities of Camp Lejeune and MCAS New River, from Richlands and Holly Ridge to Swansboro and Sneads Ferry — Fast Passport Center serves the entire Onslow County region. We regularly help military families and travelers from Hubert, Midway Park, Piney Green, and Half Moon get their passports fast.",
  nearbyCitiesIntro: "We serve all Jacksonville neighborhoods and the surrounding Onslow County area including Richlands, Holly Ridge, Sneads Ferry, Swansboro, Hubert, Camp Lejeune, MCAS New River, Midway Park, Piney Green, Half Moon, North Topsail Beach, Surf City, Hampstead, and Burgaw. If you are anywhere in Onslow, Pender, or Jones counties, we have you covered.",
  howItWorksIntro: "Most Jacksonville travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Jacksonville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Jacksonville and Camp Lejeune area travelers trust us when their deployment or departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Jacksonville? Here are the most common ones we hear from Onslow County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Jacksonville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sgt. Daniel M.",
      location: "Camp Lejeune, NC",
      rating: 5,
      text: "Deployment orders came with 36 hours notice. Fast Passport Center got my emergency passport ready in 28 hours. They understand military urgency better than anyone. Outstanding service.",
      service: "Emergency Passport",
    },
    {
      name: "Jessica W.",
      location: "Jacksonville, NC",
      rating: 5,
      text: "Family emergency in Japan and my passport was expired. They had my renewal in 32 hours. I never had to leave Onslow County. The team was compassionate and professional.",
      service: "Passport Renewal",
    },
    {
      name: "Brian C.",
      location: "Richlands, NC",
      rating: 5,
      text: "Business trip to Seoul came up with 5 days notice. Fast Passport Center got me a passport in 4 business days. The communication was excellent throughout the entire process.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah K.",
      location: "Swansboro, NC",
      rating: 5,
      text: "First passport for my daughter before her school trip to France. Fast Passport Center helped us navigate every document. Ready in 5 days with zero stress. Truly grateful.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "jacksonville-nc-1",
      name: "Jacksonville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1001 Western Blvd",
      city: "Jacksonville",
      state: "NC",
      zip: "28546",
      phone: "(910) 347-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Jacksonville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Jacksonville facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "jacksonville-nc-2",
      name: "Richlands Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8101 Richlands Hwy",
      city: "Richlands",
      state: "NC",
      zip: "28574",
      phone: "(910) 324-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Jacksonville, Onslow County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Richlands and west Jacksonville residents. Less crowded than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "jacksonville-nc-3",
      name: "Sneads Ferry Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "242 NC-210",
      city: "Sneads Ferry",
      state: "NC",
      zip: "28460",
      phone: "(910) 327-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North of Jacksonville, coastal area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sneads Ferry and North Topsail Beach area. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "jacksonville-nc-4",
      name: "Swansboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "689 W Corbett Ave",
      city: "Swansboro",
      state: "NC",
      zip: "28584",
      phone: "(910) 326-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East of Jacksonville, coastal area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Swansboro and eastern Onslow County. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "jacksonville-nc-5",
      name: "Onslow County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "625 Court St",
      city: "Jacksonville",
      state: "NC",
      zip: "28540",
      phone: "(910) 478-3600",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Onslow County Courthouse, downtown Jacksonville",
      website: "https://www.onslowcountync.gov/",
      websiteLabel: "Onslow County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "jacksonville-nc-6",
      name: "Camp Lejeune Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Bldg 825",
      city: "Camp Lejeune",
      state: "NC",
      zip: "28547",
      phone: "(910) 451-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Camp Lejeune military base",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves military personnel and families on Camp Lejeune. ID required for base access.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Jacksonville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Onslow County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Jacksonville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Onslow County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Jacksonville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Jacksonville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Jacksonville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Jacksonville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Jacksonville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Jacksonville?", a: "Fast Passport Center offers fast passport renewal in Jacksonville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Jacksonville?", a: "The nearest regional passport agency to Jacksonville is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 330 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Jacksonville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Jacksonville?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 5.5 hours from Jacksonville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Onslow County residents." },
    { q: "Do you serve military families at Camp Lejeune?", a: "Absolutely. Fast Passport Center proudly serves military families at Camp Lejeune and MCAS New River throughout the Jacksonville area. We understand the unique urgency of deployment and PCS travel. Our courier service works seamlessly from any address on or off base in Onslow County." },
    { q: "Can I expedite a child passport in Jacksonville?", a: "Yes. Fast Passport Center expedites child passports in Jacksonville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Onslow County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Jacksonville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Jacksonville", address: "2025 Western Blvd, Jacksonville, NC 28546", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Jacksonville", address: "1265 Western Blvd, Jacksonville, NC 28546", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Jacksonville", address: "2025 N Marine Blvd, Jacksonville, NC 28546", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Jacksonville", address: "1096 Western Blvd, Jacksonville, NC 28546", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Richlands", address: "8103 Richlands Hwy, Richlands, NC 28574", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Sneads Ferry", address: "243 NC-210, Sneads Ferry, NC 28460", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Swansboro", address: "665 W Corbett Ave, Swansboro, NC 28584", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Hampstead", address: "16467 US-17, Hampstead, NC 28443", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Jacksonville",
      address: "299 Wilmington Hwy, Jacksonville, NC 28540",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Richlands",
      address: "8120 Richlands Hwy, Richlands, NC 28574",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Swansboro",
      address: "688 W Corbett Ave, Swansboro, NC 28584",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves eastern Onslow County and coastal residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Hampstead",
      address: "16560 US-17, Hampstead, NC 28443",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Pender County and north Onslow County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "OAJ",
      name: "Albert J. Ellis Airport",
      distance: "15 miles northwest of downtown Jacksonville",
      address: "264 Albert Ellis Airport Rd, Richlands, NC 28574",
      note: "Primary airport for Jacksonville and Onslow County. Direct flights to major domestic hubs including Atlanta and Charlotte. American and Delta service with connections to international destinations.",
      flightUrl: "https://www.oaj-airport.com/",
      flightLabel: "OAJ Airport",
      featured: true,
    },
    {
      code: "ILM",
      name: "Wilmington International Airport",
      distance: "60 miles south of Jacksonville",
      address: "1740 Airport Blvd, Wilmington, NC 28405",
      note: "Alternative airport for coastal North Carolina travelers. Additional domestic routes.",
      flightUrl: "https://www.flyilm.com/",
      flightLabel: "ILM Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "130 miles north of Jacksonville",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub with direct flights to London, Paris, and Cancun. Consider for long-haul international travel from Onslow County.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Onslow County Register of Deeds',
      description: 'Marriage licenses and records for Onslow County. Apply in person or request certified copies.',
      url: 'https://www.onslowcountync.gov/195/Register-of-Deeds',
    },
    {
      label: 'Onslow County Clerk of Superior Court',
      description: 'Divorce records and decrees for Onslow County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/onslow-county/onslow-county-clerk-of-superior-court',
    },
  ],
};